module.exports = __webpack_public_path__ + "static/img/moments-wap.82021d2d.png";